import React from "react";
import { motion, Variants } from "framer-motion";

const whoWeAreData = [
  {
    id: 1,
    title: "Who We Are",
    desc: `Ecocyntec is a limited liability company incorporated under the laws of the United States of America. We are an engineering firm specializing in data center infrastructure solutions, Engineering, Procurement, Construction, Installation and commissioning as well as Project management services. |

Our core services include advanced liquid cooling, thermal management, performance optimization, and professional energy solutions across upstream, midstream, and downstream operations. |

We are committed to delivering exceptional services that meet the diverse needs of our clients in the energy and technology sectors. With our expertise, dedication to excellence, and customer-focused approach, we strive to provide solutions that drive success, improve operational efficiency, and support a more sustainable and innovative future.
`,
    img: require("../../../assets/whoWeAre4.png"),
  },
  {
    id: 2,
    title:
      "Building a Sustainable Future: Our Commitment to Eco-Friendly Practices",
    desc: `At Ecocyntec, we are deeply committed to promoting a sustainable future and minimizing our environmental impact. We believe in harnessing the power of eco-friendly practices to create a greener world. Our dedication to sustainability drives us to develop innovative solutions that optimize energy production, reduce carbon emissions, and preserve natural resources. Through our eco-conscious approach, we strive to lead the way in the energy industry by setting high standards for environmental stewardship. Join us in our journey towards a cleaner, healthier planet. Together, we can make a positive difference.`,

    img: require("../../../assets/whoWeAre2.png"),
  },
  {
    id: 3,
    title: "Mission Statement",
    desc: `
    Our mission is to deliver innovative engineering solutions for the energy and data center sectors, ensuring operational excellence, sustainability, and reliability while building lasting partnerships and exceeding client expectations.
           `,
    img: require("../../../assets/whoWeAre3.png"),
  },
];

const WhoWeAre = () => {
  const imageVariants = (direction: "left" | "right"): Variants => ({
    hidden: { opacity: 0, x: direction === "left" ? -100 : 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", stiffness: 100, damping: 20 },
    },
  });

  const textVariants = (direction: "left" | "right"): Variants => ({
    hidden: { opacity: 0, x: direction === "left" ? 100 : -100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", stiffness: 100, damping: 20, delay: 0.2 },
    },
  });

  return (
    <div className=" w-full h-auto flex flex-col bg-white mt-10">
      {whoWeAreData.map((item) => {
        const sentences = item.desc.split(" |");
        const isEven = item.id % 2 === 0;

        return (
          <div
            key={item.id}
            className={`w-full md:flex flex-1 items-center justify-center gap-4 md:gap-0 bg-backgroundColor px-4 md:px-8 mb-10 md:mb-0 ${
              isEven ? "flex-row md:flex-row-reverse" : ""
            }`}
          >
            <motion.img
              src={item.img}
              alt=""
              className=" w-full md:w-1/2 h-[300px] md:h-[500px] object-cover"
              variants={imageVariants(isEven ? "right" : "left")}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            />

            <motion.div
              className="w-full md:w-1/2 flex flex-col items-center justify-center py-3 md:py-0 md:p-10"
              variants={textVariants(isEven ? "right" : "left")}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
            >
              <h3 className=" font-CrimsonText font-bold text-xl md:text-2xl text-center text-primaryColor">
                {item.title}
              </h3>
              <p className=" flex flex-col font-CrimsonText font-medium text-justify md:text-justify text-base md:text-lg text-textColor mt-3">
                {sentences.map((sentence) => (
                  <span key={sentence}>
                    {sentence} <br />
                  </span>
                ))}
              </p>
            </motion.div>
          </div>
        );
      })}
    </div>
  );
};

export default WhoWeAre;
